export const ALLOCATIONS = {
    CONTROL: '1',
    TEST_B: '2',
    TEST_C: '3',
    TEST_D: '4',
};

export const EXPERIMENTS = {
    CAT_LISTINGS_PRICE_BUCKETS: 3456,
    CARIBOU_RATING_SCORE_UPDATES: 4268,
    // Houston prod experiment id 5250 (DR: public_rating_variance)
    COBRAS_PUBLIC_RATING_VARIANCE: 5250,
};

export const ROLLOUTS = {
    CROWS_CLEAN_GIG_CARD_URL: 'crows_clean_gig_card_url',
    COBRAS_PUBLIC_RATING_VARIANCE: 'cobras_public_rating_variance',
};
